import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

const columns = [
  {
    title: 'BookingID',
    dataIndex: 'BookingID',
    fixed: 'left',
    width: 100,
  },
  {
    title: 'BookingStatus',
    dataIndex: 'BookingStatus',
    fixed: 'left',
    width: 150,
  },
  {
    title: 'BookingDealerName',
    width: 200,
    dataIndex: 'BookingDealerName',
  },
  {
    title: 'BookingType',
    dataIndex: 'BookingType',
    width: 120,
  },
  {
    title: 'BookDate',
    dataIndex: 'bookDate',
    width: 120,

    render: text => moment(text).format(DATE_FORMAT),
  },
  {
    title: 'ContractNumber',
    width: 120,
    dataIndex: 'contractNumber',
  },
  {
    title: 'ClaimSubmitted',
    width: 120,
    dataIndex: 'ClaimSubmitted',
  },
  {
    title: 'CrossClaim',
    width: 120,
    dataIndex: 'CrossClaim',
  },
  {
    title: 'ClaimApproved',
    width: 120,
    dataIndex: 'claimApproved',
    render: text => (text ? moment(text).format(DATE_FORMAT) : '------'),
  },
  {
    title: 'ClaimPaid',
    width: 120,
    dataIndex: 'claimPaid',
    render: text => (text ? moment(text).format(DATE_FORMAT) : '------'),
  },
  {
    title: 'ClaimFund',
    width: 120,
    dataIndex: 'claimFund',
  },
  {
    title: 'ClaimFundincVAT',
    width: 140,
    dataIndex: 'ClaimFundincVAT',
  },
  {
    title: 'VRN',
    width: 120,
    dataIndex: 'registration',
  },
  {
    title: 'SellingDealer',
    width: 120,
    dataIndex: 'SellingDealer',
  },
  {
    title: 'ServicePlanID',
    width: 120,
    dataIndex: 'ServicePlanID',
  },
  {
    title: 'Make',
    width: 150,
    dataIndex: 'make',
  },
  {
    title: 'model',
    width: 150,
    dataIndex: 'model',
  },
  {
    title: 'FuelType',
    width: 120,
    dataIndex: 'fuelType',
  },
  {
    title: 'Transmission',
    width: 120,
    dataIndex: 'transmission',
  },
  {
    title: 'CustomerId',
    width: 120,
    dataIndex: 'CustomerId',
  },
  {
    title: 'customerLastName',
    width: 120,
    dataIndex: 'customerLastName',
  },
  {
    title: 'Funded',
    width: 120,
    dataIndex: 'funded',
  },
  {
    title: 'FundedUpfront',
    width: 120,
    dataIndex: 'fundedUpfront',
  },
  {
    title: 'FundedMonthly',
    width: 120,
    dataIndex: 'fundedMonthly',
  },
  {
    title: 'FundedTotal',
    width: 120,
    dataIndex: 'fundedTotal',
  },
  {
    title: 'TotalPlanCostIncVAT',
    width: 150,
    dataIndex: 'totalPlanCostIncVAT',
  },
  {
    title: 'Notes',
    dataIndex: 'notes',
    fixed: 'right',
    width: 120,
  },
];
export default columns;
